import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { Link } from "gatsby";

function Cutttingedge(props) {
  return (
    <div className="p-100 tekrevol_dark_bg">
      <Container className="h-100">
        <Row className="h-100">
          <Col
            xs={12}
            md={12}
            lg={12}
            xl={10}
            xxl={10}
            className="m-auto text-center"
          >
            <div className="example center text-center" data-text="App">
              <h2>
                3X Your Digital Game with Zero-Hassle Mobile App Development
              </h2>
            </div>
            <p>Rolled out adaptive & performant 100+ client apps!</p>
            <p>Get along with these successful digital ventures</p>
            <Link
              to="/contact"
              className="border_btn"
              aria-label="TekRevol Contact"
            >
              Start Your App Development Today
            </Link>
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default Cutttingedge;
